import * as tslib_1 from "tslib";
import { OnInit, NgZone } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AppLoadingEventsEmitter } from 'src/app/modules/shared/events/loading.events';
import { AuthService } from 'src/app/modules/shared/services/auth.service';
import { UsersService } from 'src/app/modules/shared/services/users.service';
import { NotificationsService } from 'src/app/modules/shared/services/notification.service';
import { LocalisationService } from 'src/app/modules/shared/services/localisation.service';
import { SocialService } from 'src/app/modules/shared/services/social.service';
import { getCookie } from '../../../shared/utilities/cookie.utilities';
import { Languages } from '../../../shared/enums/languages';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(router, appIsLoadingEventsEmitter, authService, usersService, notificationService, localisationService, socialService, ngZone) {
        this.router = router;
        this.appIsLoadingEventsEmitter = appIsLoadingEventsEmitter;
        this.authService = authService;
        this.usersService = usersService;
        this.notificationService = notificationService;
        this.localisationService = localisationService;
        this.socialService = socialService;
        this.ngZone = ngZone;
        this.loginForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.minLength(5), Validators.email]),
            password: new FormControl('', [Validators.required, Validators.minLength(5)])
        });
        this.persistLogin = false;
        this.languages = Object.keys(Languages).map(function (k) { return Languages[k]; });
        // document.body.classList.remove('app-loading');
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
    }
    LoginComponent.prototype.ngOnInit = function () {
    };
    LoginComponent.prototype.onLogin = function () {
        var _this = this;
        var email = this.loginForm.controls['email'].value;
        var password = this.loginForm.controls['password'].value;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.authService.login(email, password).subscribe(function (_a) {
            var token = _a.token;
            _this.authService.setJWT(token);
            _this.usersService.getUserProfile()
                .subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.router.navigate(['dashboard'])];
                        case 1:
                            _a.sent();
                            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                            return [2 /*return*/];
                    }
                });
            }); });
        }, function (err) {
            _this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            if (err.status === 400) {
                _this.notificationService.error(_this.localisationService.localise('auth_invalid_credentials'));
            }
            else {
                _this.notificationService.error(_this.localisationService.localise('server_err_something_went_wrong'));
            }
        });
    };
    LoginComponent.prototype.onFacebookLogin = function () {
        var _this = this;
        this.socialService.openFacebookLoginDialog().subscribe(function (_a) {
            var userID = _a.authResponse.userID;
            _this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
            _this.socialService.getFacebookInfo(userID)
                .subscribe(function (_a) {
                var email = _a.email, first_name = _a.first_name, last_name = _a.last_name;
                _this.authService.facebookLogin(email, first_name, last_name, userID, _this.localisationService.getLanguage(), getCookie('referral'))
                    .subscribe(function () {
                    _this.usersService.getUserProfile()
                        .subscribe(function () {
                        _this.ngZone.run(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.router.navigate(['dashboard'])];
                                    case 1:
                                        _a.sent();
                                        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    });
                });
            });
        });
    };
    LoginComponent.prototype.onLanguageSelected = function (locale) {
        var url = this.router.url;
        url = url.substr(0, (url.indexOf('?') !== -1 ? url.indexOf('?') : url.length));
        window.location.href = url + '?lang=' + locale.toLocaleLowerCase();
    };
    LoginComponent.prototype.flagIcon = function (language) {
        switch (language) {
            case Languages.English:
                return 'us';
            default:
                return language.toLowerCase();
        }
    };
    return LoginComponent;
}());
export { LoginComponent };
